"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function addGraphQLSubscriptions(networkInterface, wsClient) {
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        console.warn('This method becomes deprecated in the new package graphql-transport-ws. Start using the ' +
            'GraphQLTransportWSClient to make queries, mutations and subscriptions over websockets.');
    }
    return lodash_1.assign(networkInterface, {
        subscribe: function (request, handler) {
            return wsClient.subscribe(request, handler);
        },
        unsubscribe: function (id) {
            wsClient.unsubscribe(id);
        },
    });
}
exports.addGraphQLSubscriptions = addGraphQLSubscriptions;
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/helpers.js
// module id = ./node_modules/subscriptions-transport-ws/dist/helpers.js
// module chunks = 0